<style>
tr.legend-row {
    margin: 0;
    padding: 0;
}
tr.legend-row:hover {
    background-color: rgba(127, 127, 127, .11);
}
tr.legend-row td, tr.legend-row td label {
    background-color: transparent;
    cursor: inherit;
}
.color-purple {
    color:  var(--accent-purple);
}
.color-purple::before {
    background-color:  var(--accent-purple) !important;
    border-color:  var(--accent-purple) !important;
}
.color-blue::before {
    background-color: var(--accent-blue) !important;
    border-color: var(--accent-blue) !important;
}
.color-blue {
    color: var(--accent-blue);
}
.color-yellow {
    color: var(--warning);
}
.color-yellow::before {
    background-color: var(--warning) !important;
    border-color: var(--warning) !important;
}
.checkbox-separator {
    margin-left: -2px;
    position: absolute;
    font-weight: 900;
}
.checkbox-text {
    margin-left: 8px;
}

.form-check.checkbox {
    margin: 0 0 0 -18px;
}

/* Localized fix for checkbox display in legend component */
.form-check.checkbox.checkbox-success label.checkbox-alwayscheck::before {
    width: 13px !important;
    height: 13px !important;
    margin-left: -18px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    opacity: 1 !important;
    display: inline-flex !important;
    position: relative !important;
    vertical-align: middle !important;
    border-radius: 3px !important;
    transition: border 0.15s ease-in-out, color 0.15s ease-in-out !important;
    line-height: 11px !important;
    align-items: center !important;
    justify-content: center !important;
    padding-left: 2px !important;
    padding-top: 0px !important;
}
</style>

<table *ngIf="!standAloneLegend" style="border-bottom: none; margin-bottom: 0;">
    <tr>
        <td></td>
        <td>
            <label class="md">{{title}}</label>
        </td>
    </tr>
    <tr [ngClass]="highlight ? 'legend-row' : ''" *ngFor="let item of rows" style="font-size: 12px;" [ngStyle]="interactive ? { 'cursor': cursor } : { 'cursor': 'cursor' }" (click)="onclick($event, item)">
        <td *ngIf = "item.showLegend && !isStackIcons" style="width: 2.5em; text-align: center;">
            <i id="details" [ngClass]="interactive ? item.checked ? 'fa fa-lg fa-check-square fa-fw' : 'fa fa-lg fa-square-o fa-fw' : ('fa fa-lg ' + item.icon + ' fa-fw')" style="margin-bottom: 5px;" [ngStyle]="{color: item.color}"></i>
        </td>
        <td *ngIf = "item.showLegend && isStackIcons" class="fa-stack" style="width: 2.5em;">
            <i id="details" [ngClass]="interactive ? item.checked ? 'fa fa-lg fa-check-square fa-fw' : 'fa fa-lg fa-square-o fa-fw' : ('fa fa-lg ' + item.icon.split(',')[0])" style="margin-bottom: 5px;" [ngStyle]="{color: item.color}"></i>
            <i id="details" [ngClass]="interactive ? item.checked ? 'fa fa-lg fa-check-square fa-fw' : 'fa fa-lg fa-square-o fa-fw' : ('fa fa-lg ' + item.icon.split(',')[1])" style="margin-bottom: 5px;" [ngStyle]="{color: item.color}"></i>
        </td>
        <td *ngIf = "item.showLegend" style="padding-left: .5em; border-left: 2px solid; border-bottom: 5px solid white;">
            <label style="margin-bottom: 0;" [ngStyle]="colorLabels ? { 'color': item.color } : { 'color': 'inherit' }">{{item.value}} <span *ngIf="item.detail">({{item.detail}})</span></label>
        </td>
    </tr>
</table>
<table *ngIf="standAloneLegend" style="margin-left: 26px;">
    <tr>
        <td>
            <label class="md">{{title}}</label>
        </td>
    </tr>
    <tr [ngClass]="highlight ? 'legend-row' : ''" *ngFor="let item of rows" style="font-size: 12px;" [ngStyle]="interactive ? { 'cursor': cursor } : { 'cursor': 'cursor' }" (click)="onclick($event, item)">
        <td>
            <div *ngIf = "item.showLegend" class="form-check checkbox checkbox-success">
                <label class="checkbox-alwayscheck" 
                    [ngClass]="{'color-purple': item.color == 'var(--accent-purple)', 'color-blue': item.color == 'var(--accent-blue)', 'color-yellow': item.color == 'var(--warning)'}"
                ></label>
                <span class="checkbox-separator" 
                    [ngClass]="{'color-purple': item.color == 'var(--accent-purple)', 'color-blue': item.color == 'var(--accent-blue)', 'color-yellow': item.color == 'var(--warning)'}"
                >|</span>
                <span style="font-size: inherit; font-weight: 400;" class="checkbox-text">{{item.value}} <span *ngIf="item.detail">({{item.detail}})</span></span>
            </div>
        </td>
    </tr>
</table>